<template>
  <v-row no-gutters class="fill-height flex-column" style="overflow-y: auto; overflow-x: hidden;">
    <v-col cols="12" class="pr-6">
      <card-title-row :straight-title="additionalModuleName" class="pt-3 pb-5" />
      <sidebar-row>
        <sidebar-summary-counts
          add-layer-to-project
          show-count-attribute-name-as-title
          :layer-id="transmissionEasementsLayerId"
          :counts-attribute-name="transmissionEasementsCountAttributeName"
        />
      </sidebar-row>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import SidebarRow from '@/components/SidebarRow';
import SidebarSummaryCounts from '@/components/SidebarSummaryCounts';

export default {
  name: 'TransmissionEasementsSummary',
  components: { CardTitleRow, SidebarRow, SidebarSummaryCounts },
  computed: {
    additionalModuleName: get('admin/additionalModules@TRANSMISSION_EASEMENT.verbose_name'),
    transmissionEasementsLayerId: get('admin/modulesMapping@transmission_easement_2.selected_layer_id'),
    transmissionEasementsCountAttributeName: get(
      'admin/modulesMapping@transmission_easement_2.selected_attribute_name'
    ),
  },
};
</script>
